<template>
  <SupportPage class="blog" fullWidth>
    <TextBanner slot="top" columns="col-lg-12">
      <h1>The Campsite.bio Blog</h1>
      <p>Learn about all the new things going on at Campsite.bio.</p>
    </TextBanner>

    <div class="blog__grid">
      <BlogItem
        v-for="article in articles"
        :key="article.slug"
        :document="article"
      />
    </div>
  </SupportPage>
</template>

<script>
import defaultOG from '@/assets/default-og';
import TextBanner from '@/components/text-banner';
import BlogItem from '@/components/blog/blog-item';
import SupportPage from '@/components/support-page';

export default {
  async asyncData({ $content }) {
    const articles = await $content('articles')
      .only([
        'title',
        'description',
        'img',
        'imgAlt',
        'imgWidth',
        'imgHeight',
        'slug',
        'author',
        'createdAt',
        'updatedAt',
      ])
      .sortBy('createdAt', 'desc')
      .fetch();

    return {
      articles,
    };
  },

  head: {
    title: 'Blog - Campsite.bio',
    meta: [
      ...defaultOG,
      {
        hid: 'description',
        name: 'description',
        content: 'Learn about all the new things going on at Campsite.',
      },
    ],
  },

  components: {
    TextBanner,
    BlogItem,
    SupportPage,
  },
};
</script>

<style lang="scss" scoped>
.blog {
  &__grid {
    gap: 1.75rem;
    display: grid;
    grid-template-columns: 1fr;

    @media (min-width: 544px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 992px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
